import { render, staticRenderFns } from "./EpsNewNotification.vue?vue&type=template&id=0a53a0da&"
import script from "./EpsNewNotification.vue?vue&type=script&lang=js&"
export * from "./EpsNewNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports